import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
const ShowMoreButton = ({
  handleClickShowMoreButton,
  translationKey
}) => {
  return /*#__PURE__*/_jsx(Button, {
    marginBlockStart: "100",
    use: "tertiary-light",
    size: "sm",
    onClick: handleClickShowMoreButton,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKey
    })
  });
};
export default ShowMoreButton;